import JoyField from '../types/JoyField';
import JoyObjectType from '../types/objects/JoyObjectType';
import JoyObject from './JoyObject';
import JoyDataService from '../services/JoyDataService';
import { isString, isStringArray } from '../validation/TypeChecking';
import { compareStringArrays } from '../utils/Utils';
export default class JoyGroup extends JoyObject {
    /**
     * Create a new JoyGroup object.
     * @param data A map of JoyField/value pairs that define the object properties.
     */
    constructor(data) {
        super({
            id: data[JoyField.id],
            objectId: data[JoyField.objectId],
            createdAt: data[JoyField.createdAt],
            createdBy: data[JoyField.createdBy],
        });
        this.fields = [JoyField.name, JoyField.description, JoyField.users];
        this.objectType = JoyObjectType.group;
        this.update = (update) => {
            console.log('new updates for group: ' + this.id);
            let changes = [];
            let name = update[JoyField.name];
            if (isString(name) && this._name !== name) {
                this._name = name;
                changes.push(JoyField.name);
            }
            let users = update[JoyField.users];
            if (isStringArray(users) && !compareStringArrays(users, this._users)) {
                this._users = users;
                changes.push(JoyField.users);
            }
            let description = update[JoyField.description];
            if (isString(description)) {
                let exists = isString(this._description);
                if (!exists || (exists && this._description !== description)) {
                    this._description = description;
                    changes.push(JoyField.description);
                }
            }
            if (changes.length > 0) {
                super.notifyObservers(changes);
            }
        };
        if (!isString(data[JoyField.name])) {
            throw Error('Invalid field name.');
        }
        this._name = data[JoyField.name];
        if (!isStringArray(data[JoyField.users])) {
            throw Error('Invalid field users.');
        }
        this._users = data[JoyField.users];
        if (isString(data[JoyField.description])) {
            this._description = data[JoyField.description];
        }
        else {
            this._description = null;
        }
        this.initialUpdate = JoyGroup.fields;
        let listenerData = new Map();
        listenerData[JoyField.objectType] = this.objectType;
        listenerData[JoyField.id] = this.id;
        this.listener = JoyDataService.instance.documentListener(listenerData, this.update);
    }
    get name() {
        return this._name;
    }
    get users() {
        return this._users;
    }
    get description() {
        return this._description;
    }
    //Helpers
    /**
     * Set the name field of the document.
     * @param name A string.
     */
    async setName(name) {
        let data = new Map();
        data[JoyField.name] = name;
        return this.updateData(data);
    }
    /**
     * Set the description field of the document.
     * @param description A string.
     */
    async setDescription(description) {
        let data = new Map();
        data[JoyField.description] = description;
        return this.updateData(data);
    }
}
//# sourceMappingURL=JoyGroup.js.map